export const OrderTableFilter = {
  title: 'Ordenar Por:',
  deliveryDate: 'Data de Entrega',
  deliveryPostalCode: 'Código Postal',
  deliveryPeriodMorning: 'Periodo de Entrega Manhã',
  deliveryPeriodAfternoon: 'Periodo de Entrega Tarde',
  customerOrderCode: 'Número de Pedido',
  orderId: 'Número de Pedido',
  orderDate: 'Data do Pedido',
  createdAt: 'Data do Pedido',
  availableDate: 'Data Disponibilidade',
  partner: 'Transportadora',
  deliveryType: 'Tipo de Entrega',
  weight: 'Peso Total',
  volume: 'Volume Total',
  stateSeparation: 'Estado',
  validation: 'Validação',
  priority: 'Prioridade',
  stateOrder: 'Estado',
  platform: 'Plataforma',
  effectiveStatus: 'Estado',
  shippingOriginType: 'Circuito Logístico',
  confirmedDeliveryDate: 'Data de Entrega',
  createdByChannel: 'Canal de Criação',
  collectedByPartnerDate: 'Data de Expedição',
  warehouse: { warehouseName: 'Tipo de Edd', section: 'Secção' },
  supplier: {
    supplierName: 'Fornecedor',
    section: { sectionName: 'Secção' }
  },
  store: { name: 'Loja' },
  supplierOrderCode: 'Nº Pedido BO',
  mounting: 'Instalação',
  volumeTotal: 'Numero de Volumes',
  storeCode: 'Nº de Loja',
  name: 'Nome da Loja',
  platformAssociated: {platformName: 'Plataforma Regional'},
  platformName: 'Plataforma Regional',
  startPeriod: 'Slot',
  schedulingName: 'Periodo do Dia',
  city: 'Localidade',
  postalCode: 'Código Postal',
  circuit: 'Circuito Logístico',
  supplierCollectionRequestDate: 'Pedido de Recolha',
  partnerExpectedCollectionDate: 'Data de Recolha',
  deliveryPeriod: 'Periodo de Entrega',
  vehicleRegistration: 'Matricula'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/OrderTableFilter.js